module.exports = ".content {\n  padding: 0px !important; }\n\n@media screen and (max-width: 650px) {\n  .search-page .buttons {\n    width: 25px; } }\n"